<template>
    <v-container>
        <module-bar :title="title" icon="mdi-shoe-sneaker" />

        <v-card outlined>
            <v-card-text>
                <v-form v-model="valid" ref="formRunner">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-file-input label="Foto" v-model="photo1" show-size
                                accept="image/png, image/jpeg, image/bmp" :rules="rulesPhoto" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field label="Nombre" v-model="name" :rules="rulesName" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field label="Avatar" v-model="avatar" :rules="rulesAvatar" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field label="Distrito" v-model="district" :rules="rulesDistrict" />
                        </v-col>


                        <v-col cols="12" md="6">
                            <v-text-field label="Zona" v-model="zone" :rules="rulesZone" />
                        </v-col>


                        <v-col cols="12">
                            <v-textarea outlined label="Nota" v-model="note" />
                        </v-col>

                        <v-col cols="12" md="4" v-if="runner">
                            <v-img style="cursor: pointer" v-if="runner.photo" width="200" :src="runner.photo"
                                :lazy-src="runner.photo_thumb" aspect-ratio="1" contain class="grey lighten-2"
                                @click="openDialogPhoto(runner.photo, 1)">
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn v-if="schema == 'edit'" text color="red" @click="deleteRunner" :loading="loadingDeleteRunner">
                    eliminar
                    corredor</v-btn>
                <v-spacer />
                <v-btn text color="red" v-if="schema == 'edit'" @click="closeDialogRunner(null)">cancelar</v-btn>
                <v-btn :loading="loadingProcess" @click="processRunner" text color="primary">{{ schema == "new" ?
                    "GUARDAR" :
                    "EDITAR"
                }}</v-btn>
            </v-card-actions>
        </v-card>

        <!-- dialogo foto -->
        <v-dialog v-if="runner" v-model="dialogPhoto" width="800">
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                    <v-img v-if="runner.photo" :src="photoSelected" />
                </v-card-text>

                <v-card-actions>
                    <v-btn text color="red" @click="deletePhoto" :loading="loadingDeletePhoto">eliminar foto</v-btn>
                    <v-spacer />
                    <v-btn text @click="closeDialogPhoto">cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ModuleBar from "../General/ModuleBar.vue";

export default {
    components: { ModuleBar },
    props: ["schema", "title", "runner", "click"],

    mounted() {
        if (this.schema == "edit")
            this.loadRunner();
    },

    data() {
        return {
            photoSelected: "",
            district: "",
            loadingDelete: false,
            dialogPhoto: false,
            loadingDeletePhoto: false,
            valid: false,
            loadingProcess: false,
            name: "",
            avatar: "",
            zone: "",
            note: "",
            photo1: null,
            loadingDeleteRunner: false,

            rulesName: [
                (value) => (value && value.length > 0) || "Ingrese el nommbre",
            ],

            rulesAvatar: [
                (value) => (value && value.length > 0) || "Ingrese el avatar",
            ],
            rulesZone: [
                (value) => (value && value.length > 0) || "Ingrese la zona",
            ],

            rulesDistrict: [
                (value) => (value && value.length > 0) || "Ingrese el distrito o localidad",
            ],

            rulesLocation: [
                (value) => (value && value > 0) || "Seleccione la ubicacion",
            ],

            rulesPhoto: [
                (value) =>
                    !value ||
                    value.size < 4000000 ||
                    "La foto no puede pesar mas de  4 Mb!",
            ],
        };
    },

    watch: {
        click() {
            this.loadRunner();
        },

        name(value) {
            this.name = value.toUpperCase();
        },

        district(value) {
            this.district = value.toUpperCase();
        },

        zone(value) {
            this.zone = value.toUpperCase();
        },

        avatar(value) {
            this.avatar = value.toUpperCase();
        },
    },

    methods: {
        processRunner() {
            if (this.valid) {
                this.loadingProcess = true;
                setTimeout(() => {
                    let payload = new FormData();

                    payload.append("name", this.name);
                    payload.append("note", this.note);
                    payload.append("photo", this.photo1);
                    payload.append("avatar", this.avatar);
                    payload.append("zone", this.zone);
                    payload.append("district", this.district);

                    if (this.schema == "edit") payload.append("runner_id", this.runner.id);

                    let path =
                        this.schema == "new" ? "storeRunnerAction" : "updateRunnerAction";

                    this.$store
                        .dispatch(path, payload)
                        .then((res) => {
                            this.loadingProcess = false;
                            if (this.schema == "edit") this.closeDialogRunner(res);
                            this.clear();
                        })
                        .catch(() => {
                            this.loadingProcess = false;
                        });
                }, 500);
            } else {
                this.$refs.formRunner.validate();
            }
        },

        clear() {
            this.name = "";
            this.note = "";
            this.photo1 = null;
            this.district = "";
            this.zone = "";
            this.avatar = "";
            this.$refs.formRunner.resetValidation();
        },

        closeDialogRunner(data) {
            this.$emit("closeDialogRunner", data);
        },

        loadRunner() {
            if (this.runner) {
                this.name = this.runner.name;
                this.avatar = this.runner.avatar;
                this.zone = this.runner.zone;
                this.district = this.runner.district;
                this.note = this.runner.note;

            }
        },

        openDialogPhoto(photo, number) {
            this.dialogPhoto = true;
            this.photoSelected = photo;
            this.photoNumber = number;
        },

        closeDialogPhoto() {
            this.dialogPhoto = false;
            this.photoSelected = "";
        },

        deletePhoto() {
            this.$confirm({
                message: `Quieres eliminar esta foto?`,
                button: {
                    no: "No",
                    yes: "Si",
                },
                callback: (confirm) => {
                    if (confirm) {
                        this.loadingDeletePhoto = true;
                        setTimeout(() => {
                            let payload = {
                                runnerId: this.runner.id,
                            };

                            this.$store
                                .dispatch("deletePhotoRunnerAction", payload)
                                .then(() => {
                                    this.loadingDeletePhoto = false;
                                    this.photoSelected = "";
                                    this.runner.photo = null;
                                    this.dialogPhoto = false;
                                    this.photoFinish();
                                })
                                .catch(() => {
                                    this.loadingDeletePhoto = false;
                                });
                        }, 500);
                    }
                },
            });
        },

        photoFinish() {
            if (this.photoNumber == 1) {
                this.tool.photo_1 = null;
                this.tool.photo_1_short = null;
                this.tool.photo_1_thumb = null;
                this.tool.photo_1_thumb_short = null;
            }
            if (this.photoNumber == 2) {
                this.tool.photo_2 = null;
                this.tool.photo_2_short = null;
                this.tool.photo_2_thumb = null;
                this.tool.photo_2_thumb_short = null;
            }
            if (this.photoNumber == 3) {
                this.tool.photo_3 = null;
                this.tool.photo_3_short = null;
                this.tool.photo_3_thumb = null;
                this.tool.photo_3_thumb_short = null;
            }
        },

        deleteRunner() {
            this.$confirm({
                message: `Quieres eliminar este corredor, no podras revertir o recuperar la informacion?`,
                button: {
                    no: "No",
                    yes: "Si",
                },
                callback: (confirm) => {
                    if (confirm) {
                        this.loadingDeleteRunner = true;
                        setTimeout(() => {
                            this.$store
                                .dispatch("deleteRunnerAction", this.runner.id)
                                .then(() => {
                                    this.loadingDeleteRunner = false;
                                    this.runner.is_delete = true;
                                    this.closeDialogRunner(this.runner);
                                })
                                .catch(() => {
                                    this.loadingDeleteRunner = false;
                                });
                        }, 500);
                    }
                },
            });
        },

    },
};
</script>

<style></style>